// AUTO-GENERATED by scripts/build-response-manifest.mjs — do not edit by hand.
export default {
  "generatedAt": "2026-10-27T21:16:49.145Z",
  "voiceSource": "gemini",
  "voiceDir": "/audio-gemini/frog",
  "cached": [
    "ball-correct",
    "ball-reveal",
    "blocks-correct",
    "blocks-reveal",
    "bonus-all",
    "bonus-extra",
    "brother-correct",
    "brother-reveal",
    "car-correct",
    "car-reveal",
    "chicken-multi-color-ask",
    "chicken-multi-color-correct",
    "chicken-multi-color-reveal",
    "chicken-multi-correct",
    "chicken-multi-count-ask",
    "chicken-multi-count-correct",
    "chicken-multi-count-reveal",
    "chicken-multi-reveal",
    "complete-good-try",
    "complete-great",
    "cow-multi-color-ask",
    "cow-multi-color-correct",
    "cow-multi-color-reveal",
    "cow-multi-correct",
    "cow-multi-count-ask",
    "cow-multi-count-correct",
    "cow-multi-count-reveal",
    "cow-multi-reveal",
    "dad-correct",
    "dad-reveal",
    "didnt-hear",
    "doll-correct",
    "doll-reveal",
    "duck-multi-correct",
    "duck-multi-count-ask",
    "duck-multi-count-correct",
    "duck-multi-count-reveal",
    "duck-multi-reveal",
    "es-bonus-all",
    "es-bonus-extra",
    "es-chicken-multi-color-ask",
    "es-chicken-multi-color-correct",
    "es-chicken-multi-color-reveal",
    "es-chicken-multi-correct",
    "es-chicken-multi-count-ask",
    "es-chicken-multi-count-correct",
    "es-chicken-multi-count-reveal",
    "es-chicken-multi-reveal",
    "es-complete-good-try",
    "es-complete-great",
    "es-cow-multi-color-ask",
    "es-cow-multi-color-correct",
    "es-cow-multi-color-reveal",
    "es-cow-multi-correct",
    "es-cow-multi-count-ask",
    "es-cow-multi-count-correct",
    "es-cow-multi-count-reveal",
    "es-cow-multi-reveal",
    "es-didnt-hear",
    "es-duck-multi-correct",
    "es-duck-multi-count-ask",
    "es-duck-multi-count-correct",
    "es-duck-multi-count-reveal",
    "es-duck-multi-reveal",
    "es-favorite-ask",
    "es-favorite-caballo",
    "es-favorite-cerdo",
    "es-favorite-conejo",
    "es-favorite-gallina",
    "es-favorite-ganso",
    "es-favorite-hint",
    "es-favorite-not-animal",
    "es-favorite-not-farm",
    "es-favorite-oveja",
    "es-favorite-pato",
    "es-favorite-pavo",
    "es-favorite-vaca",
    "es-favorite-wrapup",
    "es-goose-color-ask",
    "es-goose-color-correct",
    "es-goose-color-reveal",
    "es-goose-correct",
    "es-goose-count-ask",
    "es-goose-count-correct",
    "es-goose-count-reveal",
    "es-goose-reveal",
    "es-great-sentence",
    "es-greeting",
    "es-horse-multi-color-ask",
    "es-horse-multi-color-correct",
    "es-horse-multi-color-reveal",
    "es-horse-multi-correct",
    "es-horse-multi-count-ask",
    "es-horse-multi-count-correct",
    "es-horse-multi-count-reveal",
    "es-horse-multi-reveal",
    "es-lets-try-another",
    "es-not-quite",
    "es-now-full-sentence",
    "es-pig-multi-color-ask",
    "es-pig-multi-color-correct",
    "es-pig-multi-color-reveal",
    "es-pig-multi-correct",
    "es-pig-multi-count-ask",
    "es-pig-multi-count-correct",
    "es-pig-multi-count-reveal",
    "es-pig-multi-reveal",
    "es-rabbit-color-ask",
    "es-rabbit-color-correct",
    "es-rabbit-color-reveal",
    "es-rabbit-correct",
    "es-rabbit-count-ask",
    "es-rabbit-count-correct",
    "es-rabbit-count-reveal",
    "es-rabbit-reveal",
    "es-say-in-spanish",
    "es-sheep-multi-color-ask",
    "es-sheep-multi-color-correct",
    "es-sheep-multi-color-reveal",
    "es-sheep-multi-correct",
    "es-sheep-multi-count-ask",
    "es-sheep-multi-count-correct",
    "es-sheep-multi-count-reveal",
    "es-sheep-multi-reveal",
    "es-so-close",
    "es-try-again",
    "es-turkey-correct",
    "es-turkey-reveal",
    "es-what-are-these-f",
    "es-what-are-these-m",
    "es-what-is-this",
    "family-correct",
    "family-reveal",
    "favorite-ask",
    "favorite-chicken",
    "favorite-cow",
    "favorite-duck",
    "favorite-generic",
    "favorite-goose",
    "favorite-hint",
    "favorite-horse",
    "favorite-not-animal",
    "favorite-not-farm",
    "favorite-not-toy",
    "favorite-pig",
    "favorite-rabbit",
    "favorite-sheep",
    "favorite-toy-ask",
    "favorite-toy-hint",
    "favorite-toy-unclear",
    "favorite-turkey",
    "favorite-wrapup",
    "gar-apple-juice-color-correct",
    "gar-apple-juice-color-reveal",
    "gar-apple-juice-correct",
    "gar-apple-juice-reveal",
    "gar-apples-color-correct",
    "gar-apples-color-reveal",
    "gar-apples-correct",
    "gar-apples-reveal",
    "gar-bananas-color-correct",
    "gar-bananas-color-reveal",
    "gar-bananas-correct",
    "gar-bananas-reveal",
    "gar-carrots-color-correct",
    "gar-carrots-color-reveal",
    "gar-carrots-correct",
    "gar-carrots-reveal",
    "gar-color-ask-p",
    "gar-color-ask-s",
    "gar-corn-color-correct",
    "gar-corn-color-reveal",
    "gar-corn-correct",
    "gar-corn-reveal",
    "gar-cucumbers-color-correct",
    "gar-cucumbers-color-reveal",
    "gar-cucumbers-correct",
    "gar-cucumbers-reveal",
    "gar-favorite-apple",
    "gar-favorite-apricot",
    "gar-favorite-avocado",
    "gar-favorite-banana",
    "gar-favorite-beet",
    "gar-favorite-blueberry",
    "gar-favorite-broccoli",
    "gar-favorite-cabbage",
    "gar-favorite-carrot",
    "gar-favorite-cauliflower",
    "gar-favorite-celery",
    "gar-favorite-cherry",
    "gar-favorite-corn",
    "gar-favorite-cucumber",
    "gar-favorite-fruit-ask",
    "gar-favorite-grape",
    "gar-favorite-kiwi",
    "gar-favorite-lemon",
    "gar-favorite-lettuce",
    "gar-favorite-mango",
    "gar-favorite-melon",
    "gar-favorite-onion",
    "gar-favorite-orange",
    "gar-favorite-peach",
    "gar-favorite-pear",
    "gar-favorite-peas",
    "gar-favorite-pepper",
    "gar-favorite-pineapple",
    "gar-favorite-plum",
    "gar-favorite-potato",
    "gar-favorite-pumpkin",
    "gar-favorite-radish",
    "gar-favorite-raspberry",
    "gar-favorite-spinach",
    "gar-favorite-squash",
    "gar-favorite-strawberry",
    "gar-favorite-tomato",
    "gar-favorite-vegetable-ask",
    "gar-favorite-watermelon",
    "gar-favorite-zucchini",
    "gar-grapes-color-correct",
    "gar-grapes-color-reveal",
    "gar-grapes-correct",
    "gar-grapes-reveal",
    "gar-great-gardener",
    "gar-hint-fruit",
    "gar-hint-vegetable",
    "gar-lemon-color-correct",
    "gar-lemon-color-reveal",
    "gar-lemon-correct",
    "gar-lemon-reveal",
    "gar-like-fruits-ask",
    "gar-like-fruits-no-reveal",
    "gar-like-fruits-yes-reveal",
    "gar-like-vegetables-ask",
    "gar-like-vegetables-no-reveal",
    "gar-like-vegetables-yes-reveal",
    "gar-not-fruit",
    "gar-not-vegetable",
    "gar-orange-juice-color-correct",
    "gar-orange-juice-color-reveal",
    "gar-orange-juice-correct",
    "gar-orange-juice-reveal",
    "gar-oranges-color-correct",
    "gar-oranges-color-reveal",
    "gar-oranges-correct",
    "gar-oranges-reveal",
    "gar-pears-color-correct",
    "gar-pears-color-reveal",
    "gar-pears-correct",
    "gar-pears-reveal",
    "gar-peppers-color-correct",
    "gar-peppers-color-reveal",
    "gar-peppers-correct",
    "gar-peppers-reveal",
    "gar-potatoes-color-correct",
    "gar-potatoes-color-reveal",
    "gar-potatoes-correct",
    "gar-potatoes-reveal",
    "gar-pumpkins-color-correct",
    "gar-pumpkins-color-reveal",
    "gar-pumpkins-correct",
    "gar-pumpkins-reveal",
    "gar-rainbow-count-ask",
    "gar-rainbow-count-correct",
    "gar-rainbow-count-reveal",
    "gar-rainbow-name-ask",
    "gar-rainbow-name-correct",
    "gar-rainbow-name-reveal",
    "gar-strawberries-color-correct",
    "gar-strawberries-color-reveal",
    "gar-strawberries-correct",
    "gar-strawberries-reveal",
    "gar-taste-ask",
    "gar-taste-lemon-correct",
    "gar-taste-lemon-reveal",
    "gar-taste-peach-correct",
    "gar-taste-peach-reveal",
    "gar-tomatoes-color-correct",
    "gar-tomatoes-color-reveal",
    "gar-tomatoes-correct",
    "gar-tomatoes-reveal",
    "goose-color-ask",
    "goose-color-correct",
    "goose-color-reveal",
    "goose-correct",
    "goose-count-ask",
    "goose-count-correct",
    "goose-count-reveal",
    "goose-reveal",
    "great-sentence",
    "greeting",
    "horse-multi-color-ask",
    "horse-multi-color-correct",
    "horse-multi-color-reveal",
    "horse-multi-correct",
    "horse-multi-count-ask",
    "horse-multi-count-correct",
    "horse-multi-count-reveal",
    "horse-multi-reveal",
    "jump-rope-correct",
    "jump-rope-reveal",
    "lets-try-another",
    "mom-correct",
    "mom-reveal",
    "not-quite",
    "now-full-sentence",
    "now-full-sentence-ok",
    "pig-multi-color-ask",
    "pig-multi-color-correct",
    "pig-multi-color-reveal",
    "pig-multi-correct",
    "pig-multi-count-ask",
    "pig-multi-count-correct",
    "pig-multi-count-reveal",
    "pig-multi-reveal",
    "playground-correct",
    "playground-reveal",
    "rabbit-color-ask",
    "rabbit-color-correct",
    "rabbit-color-reveal",
    "rabbit-correct",
    "rabbit-count-ask",
    "rabbit-count-correct",
    "rabbit-count-reveal",
    "rabbit-reveal",
    "say-in-english",
    "sch-alphabet-correct",
    "sch-alphabet-reveal",
    "sch-backpack-have-ask",
    "sch-backpack-have-no-reveal",
    "sch-backpack-have-yes-reveal",
    "sch-book-have-ask",
    "sch-book-have-no-reveal",
    "sch-book-have-yes-reveal",
    "sch-circle-correct",
    "sch-circle-reveal",
    "sch-classroom-correct",
    "sch-classroom-reveal",
    "sch-computer-have-ask",
    "sch-computer-have-no-reveal",
    "sch-computer-have-yes-reveal",
    "sch-eraser-have-ask",
    "sch-eraser-have-no-reveal",
    "sch-eraser-have-yes-reveal",
    "sch-glue-have-ask",
    "sch-glue-have-no-reveal",
    "sch-glue-have-yes-reveal",
    "sch-good-student",
    "sch-great-name",
    "sch-greeting",
    "sch-learn-ask",
    "sch-map-have-ask",
    "sch-map-have-no-reveal",
    "sch-map-have-yes-reveal",
    "sch-marker-have-ask",
    "sch-marker-have-no-reveal",
    "sch-marker-have-yes-reveal",
    "sch-notebook-have-ask",
    "sch-notebook-have-no-reveal",
    "sch-notebook-have-yes-reveal",
    "sch-oval-correct",
    "sch-oval-reveal",
    "sch-paper-have-ask",
    "sch-paper-have-no-reveal",
    "sch-paper-have-yes-reveal",
    "sch-pen-have-ask",
    "sch-pen-have-no-reveal",
    "sch-pen-have-yes-reveal",
    "sch-pencil-have-ask",
    "sch-pencil-have-no-reveal",
    "sch-pencil-have-yes-reveal",
    "sch-rectangle-correct",
    "sch-rectangle-reveal",
    "sch-ruler-have-ask",
    "sch-ruler-have-no-reveal",
    "sch-ruler-have-yes-reveal",
    "sch-school-correct",
    "sch-school-reveal",
    "sch-scissors-have-ask",
    "sch-scissors-have-no-reveal",
    "sch-scissors-have-yes-reveal",
    "sch-sorry",
    "sch-square-correct",
    "sch-square-reveal",
    "sch-star-correct",
    "sch-star-reveal",
    "sch-student-correct",
    "sch-student-reveal",
    "sch-teacher-correct",
    "sch-teacher-reveal",
    "sch-triangle-correct",
    "sch-triangle-reveal",
    "sch-yay",
    "sentence-try-again",
    "sheep-multi-color-ask",
    "sheep-multi-color-correct",
    "sheep-multi-color-reveal",
    "sheep-multi-correct",
    "sheep-multi-count-ask",
    "sheep-multi-count-correct",
    "sheep-multi-count-reveal",
    "sheep-multi-reveal",
    "sister-correct",
    "sister-reveal",
    "slide-correct",
    "slide-reveal",
    "so-close",
    "toys-correct",
    "toys-reveal",
    "try-again",
    "turkey-correct",
    "turkey-reveal",
    "what-animal-do-you-see",
    "what-animal-is-this",
    "what-are-these",
    "what-bird-do-you-see",
    "what-bird-is-this",
    "what-is-this",
    "who-is-this"
  ],
  "legacyOnly": []
};
